import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { recipes } from '../services/api';
import { fadeInUp, staggerContainer, cardHover } from '../utils/animations';
import Avatar from '../components/Avatar';
import '../styles/Home.css';

const Home = () => {
  const [latestRecipes, setLatestRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLatestRecipes();
  }, []);

  const fetchLatestRecipes = async () => {
    try {
      const response = await recipes.getAll({ approved: true });
      setLatestRecipes(response.data.slice(0, 6));
    } catch (error) {
      console.error('Error fetching recipes:', error);
    } finally {
      setLoading(false);
    }
  };

  const categories = [
    { name: 'előétel', label: 'Előételek', emoji: '🥗' },
    { name: 'leves', label: 'Levesek', emoji: '🍲' },
    { name: 'főétel', label: 'Főételek', emoji: '🍝' },
    { name: 'saláta', label: 'Saláták', emoji: '🥙' },
    { name: 'desszert', label: 'Desszertek', emoji: '🍰' },
    { name: 'pékáruk', label: 'Pékáruk', emoji: '🥖' },
    { name: 'italok', label: 'Italok', emoji: '🍹' },
    { name: 'egyéb', label: 'Egyebek', emoji: '🍽️' }
  ];

  return (
    <div className="home">
      <section className="hero">
        <motion.div
          className="container"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <h1>Üdvözöllek az oldalon, ahol együtt főzünk Érzésre!</h1>
          <p>Magyar receptek, családi hagyományok - Főzzünk együtt Érzésre!</p>
          <Link to="/recipes" className="btn btn-primary">
            Receptek Böngészése
          </Link>
        </motion.div>
      </section>

      <section className="categories">
        <div className="container">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            Kategóriák
          </motion.h2>
          <motion.div
            className="category-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {categories.map((cat) => (
              <motion.div
                key={cat.name}
                variants={fadeInUp}
                whileHover={cardHover}
                whileTap={{ scale: 0.98 }}
                style={{ display: 'contents' }}
              >
                <Link
                  to={`/recipes?category=${cat.name}`}
                  className="category-card"
                >
                  <span className="category-emoji">{cat.emoji}</span>
                  <h3>{cat.label}</h3>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <section className="latest-recipes">
        <div className="container">
          <h2>Legújabb Receptek</h2>
          {loading ? (
            <p>Betöltés...</p>
          ) : (
            <div className="recipe-grid">
              {latestRecipes.map((recipe) => (
                <Link key={recipe._id} to={`/recipe/${recipe._id}`} className="recipe-card card">
                  <div className="recipe-card-image-wrapper">
                    {recipe.coverImage ? (
                      <img
                        src={typeof recipe.coverImage === 'object' ? recipe.coverImage.medium : recipe.coverImage}
                        alt={recipe.title}
                        className="recipe-card-image"
                      />
                    ) : (
                      <div className="recipe-card-no-image">📷</div>
                    )}
                  </div>
                  <div className="recipe-card-body">
                    <h3>{recipe.title}</h3>
                    <div className="recipe-meta">
                      <span className="recipe-meta-item">
                        <span className="meta-icon">⚡</span>
                        {recipe.difficulty || 'Könnyű'}
                      </span>
                      <span className="recipe-meta-item">
                        <span className="meta-icon">⏱️</span>
                        {recipe.prepTime + recipe.cookTime} perc
                      </span>
                      <span className="recipe-meta-item">
                        <span className="meta-icon">👥</span>
                        {recipe.servings} adag
                      </span>
                    </div>
                    {recipe.author && (
                      <div className="recipe-card-author">
                        <Avatar
                          name={recipe.author.nickname || recipe.author.name}
                          imageUrl={recipe.author.profileImage}
                          size="small"
                        />
                        <span className="recipe-card-author-name">
                          {recipe.author.nickname || recipe.author.name}
                        </span>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          )}
          <div className="text-center" style={{ marginTop: '2rem' }}>
            <Link to="/recipes" className="btn btn-outline">
              Összes Recept
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
